import {
  WSGrid,
  WSPage,
  WSPanel,
  WSScreen
} from "@wingspanhq/fe-component-library";
import React from "react";
import { PaymentMethodsList } from "../../components/PaymentMethodsList/PaymentMethodsList";
import { PayoutMethodsList } from "../../components/PayoutMethodsList/PayoutMethodsList";
import { SettingsSections } from "../../components/SettingsSections/SettingsSections.component";
import { WingspanAccounts } from "./WingspanAccounts";

export const PaymentMethodsDashboard: React.FC = () => {
  return (
    <WSPage title="Payment methods">
      <WSScreen.MobileAndTablet>
        <SettingsSections
          parentPathName="/member/settings/payment-methods"
          sections={[
            {
              title: "Payout methods",
              render: () => (
                <PayoutMethodsList
                  mt="L"
                  basePath="/member/settings/payment-methods/payout-methods"
                />
              )
            },
            {
              title: "Payment methods",
              render: () => <PaymentMethodsList mt="L" />
            },
            {
              title: "Wingspan Accounts",
              render: () => <WingspanAccounts />
            }
          ]}
        />
      </WSScreen.MobileAndTablet>
      <WSScreen.Desktop>
        <WSGrid.Container>
          <WSGrid.Item M={6}>
            <WSPanel>
              <PayoutMethodsList basePath="/member/settings/payment-methods" />
            </WSPanel>
            <WingspanAccounts />
          </WSGrid.Item>
          <WSGrid.Item M={6}>
            <WSPanel>
              <PaymentMethodsList />
            </WSPanel>
          </WSGrid.Item>
        </WSGrid.Container>
      </WSScreen.Desktop>
    </WSPage>
  );
};
